export default "__VITE_ASSET__BLPDLV44__"